module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Fm02"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Note about Translation and Transliteration")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Fm03"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Note on Previously Published Material")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Acknowledgement"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01"
    }
  }, [_vm._v("1  Burying the Dead: Cemeteries, Walls, and Jewish Identity in Early Twentieth-Century Argentina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  Helping the Living: Philanthropy and the Boundaries of Sephardi Communities in Argentina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  The Limits of Community: Unsuccessful Attempts at Creating Single Sephardi Organizations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  Working for the Homeland: Zionism and the Creation of an “Argentine” Sephardi Community after 1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  Becoming Argentine, Becoming Jewish, Becoming and Remaining Sephardi: Jewish Women and Identity in Twentieth-Century Argentina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  Marriages and Schools: Living within Multiple Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Postscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·  "), _c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3498c1fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 72
// module chunks = 0